<script setup lang="ts">
const emit = defineEmits(['close'])
const props = defineProps({
  isClose: { type: Boolean, default: true },
  icon: { type: String, default: '' },
  title: { type: String, default: '' },
})
</script>

<template>
  <v-icon v-if="icon" class="me-2" color="white" size="1.5rem">
    {{ props.icon }}
  </v-icon>
  <slot name="title">
    <div class="text-subheading-strong text-center w-100">
      {{ props.title }}
    </div>
  </slot>
  <v-spacer />
  <v-btn
    v-if="props.isClose"
    icon="mdi-window-close"
    class="tw:absolute tw:right-[20px] tw:top-[20px] tw:z-20"
    size="small"
    variant="text"
    style="margin-right: -6px"
    @click="() => emit('close')"
  />
</template>
